import React from 'react';
import PropTypes from 'prop-types';
import { useMediaBreakpoint } from '@americanexpress/consumer-travel-base';
import { useMosaicContext } from '../../contexts/mosaicContext';

const TooltipFooter = ({ children }) => {
  const isMosaicDesign = useMosaicContext();
  const isMobile = useMediaBreakpoint('sm-down');

  return isMosaicDesign ? (
    <div>
      <hr className={!isMobile && 'width-auto margin-lr '} />
      <div className="pad-lr pad-b flex-align-center">
        <div className="flex flex-row flex-justify-end margin-2-t">
          {children}
        </div>
      </div>
    </div>
  ) : (
    <div>
      <hr />
      <div className="pad flex flex-row flex-align-center flex-justify-end">
        {children}
      </div>
    </div>
  );
};

TooltipFooter.propTypes = {
  children: PropTypes.node.isRequired,
};

export default TooltipFooter;
